<template>
  <div class="g-sidebar__container" id="languageSwitcher" v-if="showWidget">
      <h3 class="g-sidebar__container__header">
          <icon name="language" height="22" width="22" />
          <span>{{ $t('dashboard.languageSwitcher.header', detectedLanguage.value) }}</span>
      </h3>
      <p>{{ $t('dashboard.languageSwitcher.hello', detectedLanguage.value) }}</p>
      <i18n path="dashboard.languageSwitcher.theSignableApp" :locale="detectedLanguage.value" tag="p">
        <template v-slot:browserLanguage>
          <b>{{ detectedLanguage.label }}</b>
        </template>
      </i18n>
      <i18n path="dashboard.languageSwitcher.youCanUpdate" :locale="detectedLanguage.value" tag="p">
        <template v-slot:myProfile>
          <router-link to="/my-profile" data-ec="language_switcher_widget" data-et="link_to_my_profile"> {{ $t('companySettings.myProfile.title', detectedLanguage.value) }}</router-link>
        </template>
      </i18n>
      <v-form data-vv-scope="language-switcher-widget" ref="form" :onSubmit="switchLanguage">
        <div slot="formButtons">
          <v-button
              type="outline-3"
              href="#" :action="closeWidget"
              :disabled="submitDisabled"
              data-ec="language_switcher_widget"
              data-et="ignore_button">
            <span>{{ $t('dashboard.languageSwitcher.ignore') }}</span>
          </v-button>
          <v-button
              subtype="submit"
              class="float-right"
              type="cta-3"
              href="#"
              :disabled="submitDisabled"
              data-ec="language_switcher_widget"
              data-et="switch_language_button">
            <span>{{ $t('dashboard.languageSwitcher.yesSwitchNow', detectedLanguage.value) }}</span>
          </v-button>
        </div>
      </v-form>
    </div>
</template>

<script>
import i18n from '@/locales';
import VButton from '@/components/deprecated/atoms/Button.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import languages from '@/data/languages.json';

export default {
  name: 'v-language-switcher-widget',
  inject: {
    $validator: '$validator',
  },
  components: {
    VButton,
    VForm,
  },
  data() {
    return {
      submitDisabled: false,
    };
  },
  computed: {
    detectedLanguage() {
      return languages.find(lang => lang.altCodes.concat([lang.value]).includes(navigator.language));
    },
    showWidget() {
      return !this.$store.state.user.user.language_hint_ignored &&
          this.detectedLanguage && this.detectedLanguage.value !== this.$store.state.user.user.language;
    },
  },
  methods: {
    switchLanguage() {
      if (this.submitDisabled) {
        return;
      }
      this.submitDisabled = true;
      this.$store.dispatch('user/UPDATE', { language: navigator.language }).then(() => {
        this.$bus.$emit('renderGlobalMessage', ({ message: i18n.t('myProfile.messageProfileUpdated'), icon: 'check', type: 'success' }));
        this.ignore();
        this.submitDisabled = false;
      });
    },
    closeWidget() {
      this.ignore();
    },
    ignore() {
      this.$store.state.user.user.language_hint_ignored = true;
      this.$store.dispatch('user/UPDATE', { language_hint_ignored: this.$store.state.user.user.language_hint_ignored });
    },
  },
};

</script>
